import React, { Component } from 'react';
import 'semantic-ui-css/semantic.min.css';
import { Icon, Message, Sidebar, SidebarPusher, Menu, Accordion, Button, Container, Header, List, Input, Form, Loader, Table } from 'semantic-ui-react';
import { ajaxPost } from '../ajax';
import AnnouncementTrail from './Announcements/AnnouncementTrail';
import AttendanceTrail from './Attendance/AttendanceTrail';
import './Dashboard.css';
import PendingCountTrail from './Transactions/PendingCountTrail';

var { isTaskAvailable, empState, checkDateRange } = require('../utils');
var moment = require('moment');
var dt = moment().local();

const BlankItem = {
  Title: "",
  Message: "",
  StartDate: dt,
  EndDate: dt,
  RecordDate: dt,
};

class Dashboard extends Component {
  constructor(props) {
    super(props);

    if (props.announcement == null) {
      this.state.announcement = JSON.parse(JSON.stringify(BlankItem));
    } else {
      this.state.announcement = props.announcement;
    }
  }

  state = {
    incEmpList: [],
    sidebarOpen: false,
    announcementFormOpen: false,
    announcement: null,
    analyticsLoading: false,
    analyticsTitle: "",
    showAnalyticsEmployee: false,
    searchTerm: "",
    analyticsData: {
      totalCount: 0,
      Companies: [],
      Departments: [],
      Employees: []
    },
    openCompanyIndexes: [],
    openDeptIndexes: []
  };

  styles = {
    sideBar: {
      width: '400px',
      paddingLeft: '2em',
      paddingRight: '2em'
    },
    sideBarHeader: {
      marginTop: '20px',
      paddingTop: '5px'
    },
    empList: {
      width: '350px',
      margin: '20px',
      textAlign: 'left',
      overflowY: 'auto',
      height: '500px'
    },
    notes: {
      margin: '20px'
    },
    backButton: {
      marginRight: '10px'
    }
  };

  componentDidMount() {
    this.getIncEmpList();
  }

  getIncEmpList = () => {
    ajaxPost({
      url: 'api/Employee/getEmpWithIncompleteData',
      onSuccess: data => {
        this.setState({ incEmpList: data });
      },
      finally: () => { }
    });
  };

  onClickAnalytics = (header) => {
    this.setState({
      analyticsLoading: true,
      showAnalyticsEmployee: true,
      analyticsTitle: header,
      analyticsData: { totalCount: 0, Companies: [], Departments: [], Employees: [] },
      openCompanyIndexes: [],
      openDeptIndexes: []
    });

    ajaxPost({
      url: 'api/Analytics/ViewEmployeeAnalytics',
      data: { viewType: header },
      onSuccess: data => {
        const companies = data.Companies || [];
        const departments = data.Departments || [];

        this.setState({
          analyticsData: {
            totalCount: data.TotalCount || 0,
            Companies: companies,
            Departments: departments,
            Employees: data.Employees || []
          },
          openCompanyIndexes: companies.map((_, idx) => idx),
          openDeptIndexes: companies.flatMap((_, cidx) =>
            (departments || []).map((_, didx) => `${cidx}-${didx}`)
          )
        });
      },
      finally: () => { this.setState({ analyticsLoading: false }) }
    });
  };

  onSave() {
        this.setState({ isErrorTitle: false, isErrorMessage: false });

        if (this.state.announcement.Title === "") {
            this.setState({ Message: "Title is require", isErrorTitle: true })
        }
        if (this.state.announcement.Message === "") {
            this.setState({ Message: "Message is require", isErrorMessage: true })
        }
        if (this.state.announcement.Title === "" || this.state.announcement.Message === "")
            return;

        var res = checkDateRange(moment(this.state.announcement["StartDate"]).format("YYYY-MM-DD"), moment(this.state.announcement["EndDate"]).format("YYYY-MM-DD"));
        if (!res.Result) {
            this.setState({ Message: res.Message.replace(" Previous valid date range is going to restore.", "").replace("Previous valid start date is going to restore.", "").replace("Previous valid end date is going to restore.", ""), isError: !res.Result })
            return;
        }

        this.state.announcement.StartDate = this.state.announcement.StartDate === "" ? "1900-02-01" : this.state.announcement.StartDate;
        this.state.announcement.EndDate = this.state.announcement.EndDate === "" ? "9999-11-01" : this.state.announcement.EndDate;
        this.state.announcement.RecordDate = new Date();
        ajaxPost({
            url: 'api/Announcement/save',
            data: this.state.announcement,
            onSuccess: data => {
                this.setState({ announcementFormOpen: false });
            },
            finally: () => { }
        });
    }

  onUpdateEmpClick = (id, noDataFields) => {
    var employee = null;
    ajaxPost({
      url: "api/employee/load",
      data: { employeeID: id },
      onSuccess: data => {
        employee = JSON.parse(JSON.stringify(data));
        var params = empState;
        params.selectedEmployee = employee;
        params.noDataFields = noDataFields;
        this.setState({ params: params });
        this.props.OnUpdateEmpClick(params);
      },
      finally: () => { }
    });
  };

  handleChange = name => event => {
    this.setState({ isValid: event.target.value != null });
    var current = this.state.announcement;
    current[name] = event.target.value;
    this.setState({ announcement: current });
  };

  handleSearchChange = (e) => {
    this.setState({ searchTerm: e.target.value });
  };

  render() {
    const panels = this.state.incEmpList.map((item) => ({
      key: item._id,
      title: item.FullName,
      content: {
        content: (
          <div>
            <List bulleted animated>
              {item.NoDataFields.map((field, idx) => (
                <List.Item key={idx}>
                  <Header as='h6' color='red' size='tiny' textAlign='left'>{field}</Header>
                </List.Item>
              ))}
            </List>
            <br />
            <Button
              basic
              primary
              size='mini'
              fluid
              onClick={this.onUpdateEmpClick.bind(this, item._id, item.NoDataFields)}
            >
              Update Employee
            </Button>
          </div>
        )
      }
    }));

    return (
      <div style={{ height: '100%', overflowY: 'auto', overflowX: 'hidden' }}>
        <div>
          <Sidebar as={Menu} direction='right' animation='overlay' vertical
            visible={this.state.sidebarOpen} width='thin' style={this.styles.sideBar}>
            <div>
              <Button circular icon='close' floated='left' style={this.styles.backButton}
                onClick={() => { this.setState({ sidebarOpen: false }) }} />
              <Header textAlign='left' style={this.styles.sideBarHeader}>
                <Header.Content>Reminder</Header.Content>
              </Header>
              <p style={this.styles.notes}>
                Kindly complete the details of the following employee/s. These information are needed to include them in the upcoming payrun.
              </p>
              <Accordion styled style={this.styles.empList} panels={panels} defaultActiveIndex={0} />
            </div>
          </Sidebar>
          <Sidebar
              as={Menu}
              direction='right'
              animation='overlay'
              vertical
              visible={this.state.announcementFormOpen}
              // width='thin'
              style={this.styles.sideBar}>
              <div>
                  <Button circular icon='close' floated='left' style={this.styles.backButton} onClick={() => { this.setState({ announcementFormOpen: false }) }}></Button>
                  <Header textAlign='left' style={this.styles.sideBarHeader}>
                      <Header.Content>
                          Add Announcement
                      </Header.Content>
                  </Header>
              </div>
              <br />
              <Container>
                  <Form widths='equal'>
                      <Form.Field
                          id='txtTitle'
                          control={Input}
                          label='Title'
                          value={this.state.announcement["Title"]}
                          placeholder='Title'
                          onChange={this.handleChange("Title").bind(this)}
                          error={this.state.isErrorTitle}
                      >
                      </Form.Field>
                      <Form.Field
                          id='txtMessage'
                          control={Input}
                          label='Message'
                          value={this.state.announcement["Message"]}
                          placeholder='Message'
                          onChange={this.handleChange("Message").bind(this)}
                          error={this.state.isErrorMessage}
                      >
                      </Form.Field>
                      <Form.Field
                          id='dtpStartDate'
                          control={Input}
                          type='date'
                          label='From'
                          placeholder='Start Date'
                          value={moment(this.state.announcement["StartDate"]).format("YYYY-MM-DD")}
                          onChange={this.handleChange("StartDate").bind(this)}
                      >
                      </Form.Field>
                      <Form.Field
                          id='dtpEndDate'
                          control={Input}
                          type='date'
                          label='To'
                          placeholder='End Date'
                          value={moment(this.state.announcement["EndDate"]).format("YYYY-MM-DD")}
                          onChange={this.handleChange("EndDate").bind(this)}
                      >
                      </Form.Field>
                      {this.state.isError && <label style={{ color: 'red' }}>{this.state.Message}</label>}
                      <Button onClick={this.onSave.bind(this)}>Save</Button>
                  </Form>
              </Container>
          </Sidebar>
          <Sidebar style={{ width: "100%", maxWidth: "800px", padding: "1rem" }}
            as={Menu} animation="overlay" vertical visible={this.state.showAnalyticsEmployee} direction="right">
            <div>
              <div style={{ display: "flex", alignItems: "center", marginBottom: "1rem" }}>
                <Button
                  circular
                  icon="arrow left"
                  floated="left"
                  onClick={() => { this.setState({ showAnalyticsEmployee: false }) }}
                />
                <Header as="h2" style={{ flex: 1, textAlign: "center" }}>
                  Today's Attendance
                </Header>
              </div>
              <div style={{ display: "flex", alignItems: "center", marginTop: "1rem", marginBottom: "1rem", justifyContent: "space-between" }}>
                <Header as="h3">
                  {this.state.analyticsTitle}
                </Header>

                <Input
                  icon="search"
                  placeholder="Search..."
                  value={this.state.searchTerm}
                  onChange={this.handleSearchChange}
                />
              </div>

              {this.state.analyticsLoading && <Loader active inline="centered" />}

              <Accordion fluid styled>
                {this.state.analyticsData.Companies.map((company, cidx) => {
                  const isCompanyActive = this.state.openCompanyIndexes.includes(cidx);

                  const companyEmployees = (this.state.analyticsData.Employees || []).filter((emp) => {
                    const term = this.state.searchTerm.toLowerCase();
                    if (!term) return true;

                    const fields = [
                      emp.EmployeeNo,
                      emp.EmployeeName,
                      emp.Position,
                      emp.Schedule,
                      emp.LeaveType,
                      emp.Timelogs,
                      emp.Department,
                      emp.Company
                    ];

                    return fields.some(field =>
                      (field || "").toString().toLowerCase().includes(term)
                    );
                  }).filter(emp =>
                    (emp.Company || "Unassigned").trim() === (company || "Unassigned").trim()
                  );

                  if (companyEmployees.length === 0) return null;
                  const companyDepartments = [...new Set(companyEmployees.map(e => e.Department || "Unassigned"))];

                  return (
                    <div key={cidx}>
                      <Accordion.Title
                        active={isCompanyActive}
                        index={cidx}
                        onClick={() => {
                          this.setState((prev) => ({
                            openCompanyIndexes: isCompanyActive
                              ? prev.openCompanyIndexes.filter(i => i !== cidx)
                              : [...prev.openCompanyIndexes, cidx]
                          }));
                        }}
                      >
                        <Icon name="building" />
                        Company: {company || "(Unassigned)"}
                      </Accordion.Title>
                      <Accordion.Content active={isCompanyActive}>
                        <Accordion fluid styled>
                          {companyDepartments.map((dept, didx) => {
                            const isDeptActive = this.state.openDeptIndexes.includes(`${cidx}-${didx}`);

                            const deptEmployees = companyEmployees.filter(
                              (emp) => (emp.Department || "Unassigned").trim() === (dept || "Unassigned").trim()
                            );

                            if (deptEmployees.length === 0) return null;

                            return (
                              <div key={`${cidx}-${didx}`}>
                                <Accordion.Title
                                  active={isDeptActive}
                                  index={`${cidx}-${didx}`}
                                  onClick={() => {
                                    this.setState((prev) => ({
                                      openDeptIndexes: isDeptActive
                                        ? prev.openDeptIndexes.filter(i => i !== `${cidx}-${didx}`)
                                        : [...prev.openDeptIndexes, `${cidx}-${didx}`]
                                    }));
                                  }}
                                >
                                  <Icon name="dropdown" />
                                  Department: {dept || "(Unassigned)"}
                                </Accordion.Title>
                                <Accordion.Content active={isDeptActive}>
                                  <Table stackable fluid className="black-table">
                                    <Table.Header>
                                      <Table.Row>
                                        <Table.HeaderCell>Employee No</Table.HeaderCell>
                                        <Table.HeaderCell>Employee Name</Table.HeaderCell>
                                        <Table.HeaderCell>Position</Table.HeaderCell>
                                        {(this.state.analyticsTitle === "PRESENT" || this.state.analyticsTitle === "LATE" || this.state.analyticsTitle === "ON-LEAVE") && (
                                          <Table.HeaderCell>Schedule</Table.HeaderCell>
                                        )}
                                        {this.state.analyticsTitle === "ON-LEAVE" && (
                                          <Table.HeaderCell>Leave Type</Table.HeaderCell>
                                        )}
                                        {(this.state.analyticsTitle === "PRESENT" || this.state.analyticsTitle === "LATE") && (
                                          <Table.HeaderCell>Timelogs</Table.HeaderCell>
                                        )}
                                      </Table.Row>
                                    </Table.Header>
                                    <Table.Body>
                                      {deptEmployees.map((emp, eidx) => (
                                        <Table.Row key={eidx}>
                                          <Table.Cell>{emp.EmployeeNo}</Table.Cell>
                                          <Table.Cell>{emp.EmployeeName}</Table.Cell>
                                          <Table.Cell>{emp.Position}</Table.Cell>
                                          {(this.state.analyticsTitle === "PRESENT" || this.state.analyticsTitle === "LATE" || this.state.analyticsTitle === "ON-LEAVE") && (
                                            <Table.Cell>{emp.Schedule}</Table.Cell>
                                          )}
                                          {this.state.analyticsTitle === "ON-LEAVE" && (
                                            <Table.Cell>{emp.LeaveType}</Table.Cell>
                                          )}
                                          {(this.state.analyticsTitle === "PRESENT" || this.state.analyticsTitle === "LATE") && (
                                            <Table.Cell>{emp.Timelogs}</Table.Cell>
                                          )}
                                        </Table.Row>
                                      ))}
                                    </Table.Body>
                                  </Table>
                                </Accordion.Content>
                              </div>
                            );
                          })}
                        </Accordion>
                      </Accordion.Content>
                    </div>
                  );
                })}
              </Accordion>
            </div>
          </Sidebar>
        </div>

        <SidebarPusher>
          <br />
          <AnnouncementTrail
            onModuleSelect={this.props.onModuleSelect}
            onAddAnnouncement={() => { this.setState({ announcementFormOpen: true }) }}
          />
          <br />
          {this.state.incEmpList.length > 0 && isTaskAvailable("INCOMPLETE_EMPLOYEEDATA_NOTIFCATION") &&
            <Message negative>
              <Icon name='warning sign' />
              There are&nbsp;<b><a href='#' onClick={() => { this.setState({ sidebarOpen: !this.state.sidebarOpen }) }}>{this.state.incEmpList.length} Employees(s)</a></b>&nbsp;with incomplete details needed to include them on upcoming payroll run.
            </Message>
          }
          <br />
          {isTaskAvailable("TODAY_ATTENDANCE_VIEW") &&
            <AttendanceTrail onClick={this.onClickAnalytics} />}
          {isTaskAvailable("TRANSACTION_PENDING_VIEW") &&
            <PendingCountTrail onModuleSelect={this.props.onModuleSelect} />}
        </SidebarPusher>
      </div>
    );
  }
}

export default Dashboard;
